import { render, staticRenderFns } from "./StoreGoods.vue?vue&type=template&id=2f3c0b74&scoped=true"
import script from "./StoreGoods.vue?vue&type=script&lang=js"
export * from "./StoreGoods.vue?vue&type=script&lang=js"
import style0 from "./StoreGoods.vue?vue&type=style&index=0&id=2f3c0b74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c0b74",
  null
  
)

export default component.exports